<template>
    <v-layout
        row
        align-center
    >
        <v-flex
            class="pa-2 ma-1"
        >
            <v-btn class="ma-1 text-right" x-small color="success" @click="create()"> + Add Service</v-btn>
            <v-card
                v-for="(service, index) in services"
                :key="index"
                color="#EBEFFD"
                class="ma-1"
            >
                <v-row class="ma-1" @click="detail(service)">
                    <div>
                        <v-card-title>{{ service.name }}</v-card-title>
                        <v-card-subtitle>{{ service.description }}</v-card-subtitle>
                    </div>
                </v-row>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    name: 'services',
    props: ['services'],
    methods: {
        create() {
            window.location.href = 'service/create'
        },
        detail(s) {
            window.location.href = 'service/' + s.id + '/edit'
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Services/Services.vue